<!--
     <Filters
       :filters='[]'
       :qunits='QUnitCollection'
       @update='apply_filters(explorer_filters)'
       filter_list='['FilterSearch', 'FilterAdvanced']'
     />
-->

<template>
  <div class="filters-cont">
    <component
      v-for="fil in whitelist"
      :key="fil"
      :is="fil"
      :filters="filters"
      :qunits="qunits"
      @update="update_filters"
      :is_mobile="is_mobile"
      :props="filter_props[fil]"
      :disabled="disabled"
    />
  </div>
</template>


<style>
 .filters-cont {
   display: flex;
   gap: 1em;
   align-items: center;
 }
</style>


<script>
 import QUnit from '@/qunit/QUnit';
 import QUnitCollection from '@/qunit/QUnitCollection';
 import FilterSearch from './FilterSearch';
 import FilterDatesRange from './FilterDatesRange';
 import FilterAdvanced from './FilterAdvanced';
 import FilterUser from './FilterUser';
 import FilterProcess from './FilterProcess'
 import { QFilters } from '@/qunit/filters';
 import FilterCentro from './FilterCentro'
 import SuperFilters from './SuperFilters.vue';

 export default {
   name: 'Filters',

   components: {
     FilterSearch,
     FilterDatesRange,
     FilterAdvanced,
     FilterUser,
     FilterProcess,
     FilterCentro,
     SuperFilters,
     //SuperFilters: () => import('@/components/explorer/filters/SuperFilters'),
   },

   props: {
     filters: {type: QFilters, required: false},
     filter_list: {required: false, default: null},
     filter_props: {required: false, default: () => ({})},
     qunits: {type: QUnitCollection, required: false},
     is_mobile: {type: Boolean, default: false},
     disabled: Boolean,
   },

   data: () => ({
     default_list: [
       'FilterCentro',
       'FilterProcess',
       'FilterSearch',
       'FilterDatesRange',
       'FilterAdvanced',
     ],
   }),

   computed: {
     whitelist() {
       if (this.filter_list !== null)
         return this.filter_list;
       return this.default_list;
     },
   },

   methods: {
     update_filters(new_filters) {
       this.$emit('update', new_filters);
     },
   },
 }
</script>
